<template>
    <div class="bbcd">
        <el-card style="padding-top:40px">
            <!-- <div class="d1" @click="go('./bbyk')">
                油卡报表
            </div> -->
            <div class="d2" @click="go('./bbhome')">
                车辆报表
            </div>
            <!-- <div class="d2" @click="go('./allcar')">
                所有车辆
            </div> -->
            <div class="d2" @click="go('./jzmx')">
                加注明细
            </div>
        </el-card>
    </div>
</template>

<script>

export default {
    data() {
        return {
          
        };
    },
    
    methods: {
        go(n) {
            this.$router.push(n)
        }
    },
};
</script>
<style lang="less" scoped>
.bbcd {
    .d1 {
        border: solid 1px red;
        text-align: center;
        height: 80px;
        line-height: 80px;
        font-weight: 600;
        margin-bottom: 20px;
    }
    .d2 {
        border: solid 1px red;
        text-align: center;
        height: 80px;
        line-height: 80px;
        font-weight: 600;
        margin-bottom: 20px;
    }
}
</style>

